import $ from 'jquery';

let $searchContainer = $('.nav-search-container'),
  $searchToggle = $('.open-search'),
  $modalOverlay = $('.modal-overlay.menu');
  
  $searchToggle.on('click', (e) => {
    $searchContainer.toggleClass('view');

  if ($searchContainer.hasClass('view')) {
    $searchToggle[0].innerHTML = '<i class="ss-community">close</i>'
    modalToggle('block', '-1');
    closeSearch();
  } else {
    $searchToggle[0].innerHTML = '<i class="ss-community">search</i>'
    modalToggle('none', '10')
  }
});


function closeSearch() {
  $('.modal-overlay.menu').on('click', (e) => {
    $searchContainer.removeClass('view')
    $searchToggle[0].innerHTML = '<i class="ss-community">search</i>'
    $modalOverlay.css('display', 'none')
    $modalOverlay.css('z-index', '10')
  });
  // $(window).on('scroll', function(){
  //   $searchContainer.removeClass('view');
  //   $searchToggle[0].innerHTML = '<i class="ss-community">search</i>'
  //   $modalOverlay.css('display', 'none')
  //   $modalOverlay.css('z-index', '10')
  // });
}

function modalToggle(display, zIndex) {
  $modalOverlay.css('display', display)
  $modalOverlay.css('z-index', zIndex)
}
